if(!customElements.get('cf-home-campaigns')){
  customElements.define('cf-home-campaigns',class extends HTMLElement{
    connectedCallback(){
      this.controller?.abort();
      this.controller=new AbortController();
      const opts={signal:this.controller.signal};
      this.slides=[...this.querySelectorAll('[data-slide]')];
      this.buttons=[...this.querySelectorAll('[data-select]')];
      this.index=0;this.request=0;this.swipedAt=-1000;
      this.querySelector('[data-previous]')?.addEventListener('click',()=>this.show(this.index-1),opts);
      this.querySelector('[data-next]')?.addEventListener('click',()=>this.show(this.index+1),opts);
      this.buttons.forEach(button=>button.addEventListener('click',()=>this.show(Number(button.dataset.select)),opts));
      const stage=this.querySelector('[data-stage]');
      stage.addEventListener('keydown',event=>{
        const targets={ArrowLeft:this.index-1,ArrowRight:this.index+1,Home:0,End:this.slides.length-1};
        if(!(event.key in targets))return;
        event.preventDefault();this.show(targets[event.key]);
      },opts);
      stage.addEventListener('pointerdown',event=>{this.start={x:event.clientX,y:event.clientY,id:event.pointerId};},opts);
      stage.addEventListener('pointerup',event=>{
        if(!this.start||this.start.id!==event.pointerId)return;
        const dx=event.clientX-this.start.x,dy=event.clientY-this.start.y;this.start=null;
        if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.4){this.swipedAt=performance.now();this.show(this.index+(dx<0?1:-1));}
      },opts);
      stage.addEventListener('pointercancel',()=>{this.start=null;},opts);
      stage.addEventListener('click',event=>{if(performance.now()-this.swipedAt<500){event.preventDefault();event.stopPropagation();}}, {...opts,capture:true});
      document.addEventListener('shopify:block:select',event=>{
        const index=this.slides.findIndex(slide=>slide.dataset.blockId===event.detail?.blockId);
        if(index>=0)this.show(index);
      },opts);
    }
    async show(value){
      const index=(value+this.slides.length)%this.slides.length;
      if(index===this.index){this.request++;this.removeAttribute('aria-busy');return;}
      const request=++this.request,slide=this.slides[index],image=slide.querySelector('img');
      this.setAttribute('aria-busy','true');image.loading='eager';
      try{await image.decode();}catch{}
      if(request!==this.request||!this.isConnected)return;
      this.slides.forEach((item,i)=>{item.hidden=i!==index;});
      this.buttons.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
      this.index=index;this.removeAttribute('aria-busy');
      const status=this.querySelector('[data-status]');if(status)status.textContent=slide.dataset.label;
    }
    disconnectedCallback(){this.request++;this.controller?.abort();}
  });
}
